<template>
    <CreateNewTrim :isDuplicate="true"></CreateNewTrim>
</template>

<script>
    import CreateNewTrim from "./CreateNewTrim";

    export default {
        name: "DuplicateTrim",

        components: {
            CreateNewTrim,
        },

    }
</script>

<style scoped>

</style>